import { formatCurrency } from '../blocos/tipos';
import type { DadosInicio } from './useDadosInicio';
import { CardBento, Rotulo, Sub } from './ui';
import { useMascara } from '../../valores-ocultos/contexto';

/**
 * Inadimplência: o anel com a fatia da carteira em atraso — a caixinha
 * clicável do v3. Os nomes (top de atrasos) e a tendência de 30 dias moram
 * na página de Inadimplentes; aqui é o número e a porta. O card aparece
 * sempre: inadimplência zero é notícia boa, não card vazio.
 */

export const CardInadimplencia = ({
  data,
  navigate,
}: {
  data: DadosInicio;
  navigate: (to: string) => void;
}) => {
  const m = useMascara();
  const pct =
    data.vendasAtivasCount > 0 ? (data.inadCount * 100) / data.vendasAtivasCount : 0;
  const pctTexto = pct.toFixed(1).replace('.', ',');

  // O anel: circunferência de r=17 ≈ 106,8. A fatia é proporcional ao pct.
  const fatia = Math.min(106.8, (pct / 100) * 106.8);

  return (
    <CardBento>
      <button
        type="button"
        onClick={() => navigate('/inadimplentes')}
        className="block w-full cursor-pointer text-left"
      >
        <Rotulo>Inadimplência</Rotulo>
        <div className="mt-2.5 flex items-center gap-3.5">
          <svg viewBox="0 0 42 42" className="h-[46px] w-[46px] shrink-0">
            <circle cx="21" cy="21" r="17" fill="none" stroke="var(--primary)" strokeOpacity="0.12" strokeWidth="6" />
            {fatia > 0 && (
              <circle
                cx="21"
                cy="21"
                r="17"
                fill="none"
                stroke="#b45309"
                strokeWidth="6"
                strokeDasharray={`${fatia} 106.8`}
                strokeLinecap="round"
                transform="rotate(-90 21 21)"
              />
            )}
          </svg>
          <div>
            <p className="text-[22px] font-bold leading-none tracking-[-0.03em] tabular-nums">
              {m(`${pctTexto}%`)}
            </p>
            <Sub className="mt-1.5">
              {data.inadCount === 0
                ? 'nenhum contrato em atraso'
                : `${m(data.inadCount)} ${data.inadCount === 1 ? 'contrato' : 'contratos'} · ${m(formatCurrency(data.inadValor, true))}`}
            </Sub>
          </div>
        </div>
        <Sub className="mt-2.5">
          <span className="font-semibold text-primary">Abrir atrasos →</span>
        </Sub>
      </button>
    </CardBento>
  );
};
